import { GatsbyImage } from 'gatsby-plugin-image'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import React from 'react'
import { BlackWrapper } from '../components'
import { CardImageProps } from '../types'

export const CardImage = ({
  caption1,
  caption2,
  imageFile,
  imageTitle,
}: CardImageProps) => {
  return (
    <BlackWrapper largePadding>
      <div className="flex mb-16 flex-wrap">
        <div className="image-caption">{renderRichText(caption1)}</div>
        <div className="image-caption">{renderRichText(caption2)}</div>
      </div>
      <GatsbyImage
        className="h-auto w-full"
        imgStyle={{
          objectPosition: 'center',
        }}
        image={imageFile}
        alt={imageTitle}
        objectFit="contain"
      />
    </BlackWrapper>
  )
}
